module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av756-6102550af1350c6e769de4fa3b574e4e.jpg";